import React from 'react';
import { useDraggable } from '../../hooks/useDraggable';
import FormattedResponse from './FormattedResponse';

const PerformanceSummaryModal = ({ performanceSummary, lastAssistantMessage, onClose }) => {
  const { position, modalRef, startDrag } = useDraggable(100, 100);

  return (
    <div className="performance-summary-modal-overlay">
      <div
        className="performance-summary-modal"
        onClick={e => e.stopPropagation()}
        onMouseDown={startDrag}
        ref={modalRef}
        style={{ left: `${position.x}px`, top: `${position.y}px` }}
      >
        <button
          className="close-summary-btn"
          onClick={onClose}
          aria-label="Close Summary"
        >
          &times;
        </button>
        <h2 style={{ color: "#405159" }}>Performance Summary</h2>
        <div className="formatted-passage">
          <FormattedResponse response={lastAssistantMessage} isModal={true} />
        </div>
        <h4 className="modal-examples-title">Summary</h4>
        <p className="summary-text">{performanceSummary}</p>
        <button className="return-button" onClick={onClose}>
          Return to Modules
        </button>
      </div>
    </div>
  );
};

export default PerformanceSummaryModal;
